const BigSmall = [
    {id: "0", value: "小於"},    
    {id: "1", value: "大於"},
  ];  
  
  export default BigSmall  